// I Ching: 8 trigrams and 64 hexagrams in the King Wen order.
// Lines are listed bottom → top, 1 = yang (solid), 0 = yin (broken).

export const TRIGRAMS = {
  qian: [1, 1, 1], // Heaven
  dui: [1, 1, 0], // Lake
  li: [1, 0, 1], // Fire
  zhen: [1, 0, 0], // Thunder
  xun: [0, 1, 1], // Wind
  kan: [0, 1, 0], // Water
  gen: [0, 0, 1], // Mountain
  kun: [0, 0, 0], // Earth
};

// [upper, lower] for hexagrams 1…64
const PAIRS = [
  ['qian', 'qian'], ['kun', 'kun'], ['kan', 'zhen'], ['gen', 'kan'], ['kan', 'qian'], ['qian', 'kan'],
  ['kun', 'kan'], ['kan', 'kun'], ['xun', 'qian'], ['qian', 'dui'], ['kun', 'qian'], ['qian', 'kun'],
  ['qian', 'li'], ['li', 'qian'], ['kun', 'gen'], ['zhen', 'kun'], ['dui', 'zhen'], ['gen', 'xun'],
  ['kun', 'dui'], ['xun', 'kun'], ['li', 'zhen'], ['gen', 'li'], ['gen', 'kun'], ['kun', 'zhen'],
  ['qian', 'zhen'], ['gen', 'qian'], ['gen', 'zhen'], ['dui', 'xun'], ['kan', 'kan'], ['li', 'li'],
  ['dui', 'gen'], ['zhen', 'xun'], ['qian', 'gen'], ['zhen', 'qian'], ['li', 'kun'], ['kun', 'li'],
  ['xun', 'li'], ['li', 'dui'], ['kan', 'gen'], ['zhen', 'kan'], ['gen', 'dui'], ['xun', 'zhen'],
  ['dui', 'qian'], ['qian', 'xun'], ['dui', 'kun'], ['kun', 'xun'], ['dui', 'kan'], ['kan', 'xun'],
  ['dui', 'li'], ['li', 'xun'], ['zhen', 'zhen'], ['gen', 'gen'], ['xun', 'gen'], ['zhen', 'dui'],
  ['zhen', 'li'], ['li', 'gen'], ['xun', 'xun'], ['dui', 'dui'], ['xun', 'kan'], ['kan', 'dui'],
  ['xun', 'dui'], ['zhen', 'gen'], ['kan', 'li'], ['li', 'kan'],
];

export const HEXAGRAMS = PAIRS.map(([upper, lower], i) => ({
  number: i + 1,
  upper,
  lower,
  lines: [...TRIGRAMS[lower], ...TRIGRAMS[upper]],
}));

const BY_LINES = new Map(HEXAGRAMS.map(h => [h.lines.join(''), h]));

export function hexagramByLines(lines) {
  return BY_LINES.get(lines.join(''));
}
